var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** Symbols recognized by the language, longest first. */
var SYMBOLS = ['>=', '<=', '!=', '..', '=', '>', '<', ':', '~', '(', ')'];
var isWhitespace = function (character) { return /\s/.test(character); };
var symbolAt = function (text, index) {
    return SYMBOLS.find(function (symbol) { return text.startsWith(symbol, index); });
};
/**
 * Splits the query text into word, quoted-phrase and symbol tokens.
 * Never throws — an unterminated quote yields a token flagged `unterminated`.
 */
export var tokenize = function (text) {
    var tokens = [];
    var index = 0;
    while (index < text.length) {
        var character = text[index];
        var symbol = character === '"' ? undefined : symbolAt(text, index);
        if (isWhitespace(character)) {
            index += 1;
        }
        else if (character === '"') {
            // CZNA-217: `\"` and `\\` inside quotes escape the quote and the backslash, so a
            // value (a regular expression above all) can carry both. Any other backslash
            // sequence is kept verbatim — `\u0158` must reach the regex engine untouched.
            var cursor = index + 1;
            var value = '';
            var closed_1 = false;
            while (cursor < text.length && !closed_1) {
                var current = text[cursor];
                if (current === '\\' && (text[cursor + 1] === '"' || text[cursor + 1] === '\\')) {
                    value += text[cursor + 1];
                    cursor += 2;
                }
                else if (current === '"') {
                    closed_1 = true;
                }
                else {
                    value += current;
                    cursor += 1;
                }
            }
            var end = closed_1 ? cursor + 1 : text.length;
            tokens.push(__assign({ type: 'quoted', raw: text.slice(index, end), value: value, span: { start: index, end: end } }, (closed_1 ? {} : { unterminated: true })));
            index = end;
        }
        else if (symbol) {
            // `..` inside a word (e.g. `1990..2000`) is handled here naturally
            // because words break on symbols below.
            tokens.push({
                type: 'symbol',
                raw: symbol,
                value: symbol,
                span: { start: index, end: index + symbol.length },
            });
            index += symbol.length;
        }
        else {
            var end = index;
            while (end < text.length &&
                !isWhitespace(text[end]) &&
                text[end] !== '"' &&
                !symbolAt(text, end)) {
                end += 1;
            }
            tokens.push({
                type: 'word',
                raw: text.slice(index, end),
                value: text.slice(index, end),
                span: { start: index, end: end },
            });
            index = end;
        }
    }
    return tokens;
};
/** Wraps a value in quotes when it would not survive tokenization intact. */
export var quoteIfNeeded = function (value) {
    var needsQuoting = value.length === 0 ||
        /\s/.test(value) ||
        value.includes('"') ||
        SYMBOLS.some(function (symbol) { return value.includes(symbol); });
    if (!needsQuoting) {
        return value;
    }
    // CZNA-217: escape instead of dropping quotes, so the value round-trips.
    return "\"".concat(value.replace(/\\/g, '\\\\').replace(/"/g, '\\"'), "\"");
};
